import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type Surcharge} from 'web-app/react/entities/surcharges/model';

const domain = 'MODALS/SURCHARGE-MODAL';

export const {action: showAddSurchargeModal} = createAction(
    `${domain}/CREATE`,
    (institutionId: string, billPayerId: string, showAccountSelection: boolean) => ({
        billPayerId,
        institutionId,
        showAccountSelection,
    }),
);

export const {action: showEditSurchargeModal} = createAction(
    `${domain}/EDIT`,
    (institutionId: string, billPayerId: string, surcharge: Surcharge, showAccountSelection: boolean) => ({
        billPayerId,
        institutionId,
        surcharge,
        showAccountSelection,
    }),
);

export const {action: hideSurchargeModal} = createAction(`${domain}/HIDE`, () => ({}));
